<template>
  <div class="order-detail-card-wrap">
    <h4 class="order-detail-status-title-wrap">
      <!-- {{ orderDetail.statusDesc || "-" }} -->
      {{ orderDetail.orderStatusTitle || "-" }}
    </h4>
    <span class="car-tag" v-if="orderDetail.estimatedDeliveryDate">
      {{ orderDetail.estimatedDeliveryDate }}
    </span>
    <h5 class="card-title">我的 {{ orderDetail.carSeriesName }}</h5>
    <div class="version-title">{{ orderDetail.carTypeName }}</div>
    <div class="detail-wrap">
      <!-- <h6 class="pc">{{ orderDetail.carModelName }}</h6>
      <div class="version-wrap pc">{{ orderDetail.carTypeName }}</div> -->
      <div class="order-detail-car-wrap ">
        <img :src="orderDetail.img" alt="" />
        <div class="item-wrap">
          <h6 class="pad">合创 {{ orderDetail.carModelName }}</h6>
          <div class="version-wrap pad">{{ orderDetail.carTypeName }}</div>
          <div
            class="item-line"
            v-for="(item, index) in orderDetail.optionalVoList"
            :key="index"
          >
            <div class="item-lf">
              <span v-if="item.groupTypeDesc" class="item-groupTypeDesc">{{
                item.groupTypeDesc
              }}</span>
              <div class="item-lf-name">
                <OverMarqueeText :text="item.name"></OverMarqueeText>
              </div>
            </div>
            <em>{{ item.displayPrice }}</em>
          </div>
        </div>
      </div>
      <div
        class="order-detail-discountList"
        v-if="orderDetail.discountList && orderDetail.discountList.length"
      >
        <div class="discountList-title">订单已享受以下折扣</div>
        <div
          class="discountList-item"
          v-for="(c, idx) in orderDetail.discountList"
          :key="idx"
        >
          <div>{{ c.discountName }}</div>
          <div>{{ c.discountMoney }}</div>
        </div>
      </div>
      <div class="order-detail-floor flex">
        <!-- v-if="
          orderDetail.status != 8 &&
            orderDetail.status != 14 &&
            orderDetail.status != 31
        " -->
        <p>
          <span>购车总价</span>
          <em
            >¥{{
              orderDetail.carPriceData
                ? orderDetail.carPriceData.subsidyTotalPrice.toLocaleString()
                : "-"
            }}</em
          >
        </p>
        <!-- // orderDetail.carPriceData.subsidyTotalPrice.toLocaleString() -->
        <p v-if="orderDetail.status != 8">
          <span> {{ statusPayText(orderDetail.status) }}</span>
          <em
            >¥
            {{
              orderDetail.status === 20
                ? orderDetail.payMoney
                : orderDetail.status >= 21
                ? orderDetail.paidPrice
                : "-"
            }}</em
          >
        </p>
        <div
          class="purchase-info-btn"
          v-if="orderDetail.status === 20 && clientWidth < 1440"
          @click="handleShowPayDialog()"
        >
          立即支付 ¥
          {{
            orderDetail.payMoney || orderDetail.payData
              ? orderDetail.payData.paidPrice
              : "-"
          }}
        </div>
      </div>
    </div>
    <!-- 支付定金弹窗 -->
    <PayDialog v-model="showPayDialog" :detail="QrCodeData" />
  </div>
</template>
<script>
import OverMarqueeText from "@components/OverMarqueeText/index.vue";
import PayDialog from "@components/PayDialog";
import { orderPay } from "@api/order";
export default {
  name: "orderDetail",
  components: { PayDialog, OverMarqueeText },
  props: {
    orderDetail: {
      type: Object,
    },
    orderId: {
      type: String,
    },
  },
  data() {
    return {
      showPayDialog: false,
      QrCodeData: {},
      clientWidth: 0,
    };
  },

  computed: {
    statusPayText() {
      return function(status) {
        switch (status) {
          case 20: //20=定金待支付（大定待支付）
            return "待支付";
          case 21: //21=定金已支付（订单确认中）
          case 22: //22=在线生产中
          case 23: //23=到达交付地
          case 24: //24=已提车
          case 25: //25=车辆运输中
          case 30: //30=修改审批中
          case 31: //31=退订处理中
            return "已支付";
          default:
            return "已支付";
        }
      };
    },
  },
  mounted() {
    this.clientWidth = document.body.clientWidth;
  },
  methods: {
    handleShowPayDialog() {
      this.getOrderPay(this.orderId);
    },
    async getOrderPay(carOrderBaseId) {
      const params = { carOrderBaseId };
      await orderPay(params).then((res) => {
        console.log("支付二维码", res);
        this.QrCodeData = res.data;
        this.showPayDialog = true;
      });
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
* {
  font-style: normal;
}
//订单详情
.order-detail-card-wrap {
  padding: 0 40px;
  font-style: normal;
  letter-spacing: 0.5px;
  @include media(
    (
      $home-lg: (
        margin-bottom: 40px,
      ),
      $home-bg: (
        padding: 0 20px,
        margin-bottom: 40px,
      ),
      $home-md: (),
      $home-sm: (
        padding: 0,
      ),
    )
  );
  .card-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    color: #000;
  }
  .version-title {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color: #000;
    margin: 5px 0 20px 0;
  }
  .car-tag {
    font-size: 12px;
    font-weight: 500;
    line-height: 19px;
    color: #0099ff;
    padding: 2px 15px;
    border-radius: 62px;
    background: #e6f8fd;
    display: block;
    @include media(
      (
        $home-lg: (
          display: none,
        ),
        $home-bg: (
          display: none,
        ),
        $home-md: (
          margin: 10px 0 40px,
          display: inline-block,
        ),
        $home-sm: (
          margin: 10px 0 40px,
        ),
      )
    );
  }
}

.order-detail-status-title-wrap {
  font-family: PingFang SC;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 44px;
  color: #000;
  margin-bottom: 40px;
  @include media(
    (
      $home-lg: (),
      $home-bg: (),
      $home-md: (
        margin-bottom: 0,
      ),
      $home-sm: (
        margin-bottom: 0,
      ),
    )
  );
}

//订单车信息
.detail-wrap {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 15px;
  h6 {
    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
  }
  .version-wrap {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 46px;
    @include media(
      (
        $home-lg: (),
        $home-bg: (),
        $home-md: (
          margin-bottom: 0,
          padding: 5px,
        ),
        $home-sm: (),
      )
    );
  }
  .order-detail-car-wrap {
    display: flex;
    @include media(
      (
        $home-lg: (
          flex-wrap: nowrap,
          flex-direction: row-reverse,
          justify-content: space-between,
        ),
        $home-bg: (
          flex-wrap: wrap,
        ),
        $home-md: (
          display: block,
        ),
        $home-sm: (),
      )
    );

    //ui/ux 广超 1441-1839 之间图片变形，需单独处理
    @media (max-width: 1840px) {
      flex-wrap: wrap;
    }
    img {
      max-width: 420px;
      height: auto;
      display: block;
      margin: 0 auto;
      object-fit: contain;
      @include media(
        (
          $home-lg: (),
          $home-bg: (),
          $home-md: (
            display: block,
            margin: 0 auto,
            max-width: 100%,
            max-height: 100%,
          ),
          $home-sm: (
            max-width: 100%,
            max-height: 100%,
          ),
        )
      );
    }
    & > div {
      width: 50%;
      padding-bottom: 46px;

      &.item-wrap {
        overflow: hidden;
        //ui/ux 广超 1441-1839 之间图片变形，需单独处理
        @media (max-width: 1840px) {
          width: 100%;
          margin-right: 0px;
        }
        @include media(
          (
            $home-lg: (
              width: 50%,
              margin-right: 40px,
              padding-bottom: 0px,
            ),
            $home-bg: (
              width: 100%,
              margin-right: 0px,
            ),
            $home-md: (
              width: 100%,
              margin-right: 0px,
            ),
            $home-sm: (
              margin-right: 0px,
            ),
          )
        );
      }
    }
    .item-wrap {
      .item-line {
        display: flex;
        justify-content: space-between;
        font-family: PingFang SC;
        font-style: normal;
        padding-bottom: 15px;
        .item-lf {
          display: flex;
          align-items: center;
          flex: 1;
          font-size: 14px;
          line-height: 22px;
          overflow: hidden;
          .item-lf-name {
            flex: 1;
            overflow: hidden;
          }
          .item-groupTypeDesc {
            white-space: nowrap;
            color: #636569;
            &::after {
              content: "";
              display: inline-block;
              width: 1px;
              height: 0.9em;
              background-color: #636569;
              margin: 0 8px;
            }
          }
          span {
            color: #000;
          }
        }

        em {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: #4c4f59;
          font-style: normal;
        }
      }
    }
  }
  .order-detail-discountList {
    padding: 15px 0;
    border-top: 1px solid #eee;
    color: #636569;
    font-size: 14px;
    line-height: 22px;
    .discountList-title {
      margin-bottom: 10px;
      color: #000;
    }
    .discountList-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .order-detail-floor {
    padding-top: 15px;
    border-top: 1px solid #eee;
    p {
      display: flex;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      span {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #636569;
      }
      em {
        font-family: Saira;
        font-size: 19px;
        font-style: normal;
        font-weight: 500;
        color: #000;
      }
    }
  }
}
.purchase-info-btn {
  font-size: 14px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #131415;
  height: 40px;
  border-radius: 72px;
  box-sizing: border-box;
  cursor: pointer;
  &.white {
    border: 1px solid #ccc;
    color: #000;
    background-color: #fff;
  }

  @include media(
    (
      $md: (
        flex-grow: 1,
      ),
      $sm: (
        flex-grow: 1,
      ),
    )
  );
}
</style>
